import React, { type ComponentType } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import type { OnboardingTourProps } from './types.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCopyPasteTour = lazyAfterPaint<ComponentType<OnboardingTourProps>>(
	() => import(/* webpackChunkName: "async-jira-list-text-cell-copy-paste-tour" */ './main'),
	{ ssr: false },
);

export function CopyPasteTourAsync(props: OnboardingTourProps) {
	return (
		<Placeholder name="copy-paste-onboarding-tour" fallback={props.children}>
			<LazyCopyPasteTour {...props} />
		</Placeholder>
	);
}
